import { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";

import {
	API_URL,
	scroll,
	createMarkup,
	getValFromLS,
	setValToLS,
	isAllowedHotel,
} from "../helpers";

import Hdg from "../components/Hdg";
import Notice from "../components/Notice";
import Alert from "../components/Alert";

import Table from "./Table";
//import Locked from "./Locked";
//import Assignments from "./Assignments";
import Nav from "./Nav";

/* use as default notice when needed
   type: "error",
  text: "Participant Registration is Locked",
*/

const Dashboard = () => {
	const [user, setUser] = useState({});
	const [level, setLevel] = useState({});
	const [golf, setGolf] = useState({});
	const [sporting, setSporting] = useState({});
	const [welcome, setWelcome] = useState({});
	const [gift, setGift] = useState({});
	const [html, setHtml] = useState({});
	const [open, setOpen] = useState({
		level: false,
		golf: false,
		sporting: false,
		welcome: false,
		gift: false,
	});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();
	const location = useLocation();

	useEffect(() => {
		//console.log(location.state);

		if (location.state && location.state.message) {
			setNotice({
				type: location.state.message.type,
				text: location.state.message.text,
			});
		}
	}, [location]);

	useEffect(() => {
		scroll();
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardInit`);
			const params = {
				id: auth.id ? auth.id : "",
				type: auth.type ? auth.type : "",
				dashId: str ? str : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					const auth = {
						id: json.id,
						type: json.type,
						fname: json.fname,
						lname: json.lname,
						email: json.email,
						organization: json.organization || "",
						liaison: json.liaison,
						dashboardUrl: json.dashboardUrl,
					};
					setValToLS("dash", JSON.stringify(auth), true);
					setUser({ ...auth });
					setLevel({ ...json.level, jwStatus: json.jwStatus });
					setGolf({ ...json.golf });
					setSporting({ ...json.sporting });
					setWelcome({ ...json.welcome });
					setGift({ ...json.gift });
					setHtml({ right: json.right });
					setAlert({});
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleToggle = (id) => {
		const newOpen = !open[id];
		setOpen({ ...open, [id]: newOpen });
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Dashboard Home" home={true} />

						<a className="dashboard" href={user.dashboardUrl}>
							<i className="fa fa-angle-left fa-2x" />
							<span>Main Sponsor Dashboard</span>
						</a>

						<p>
							The 2027 Valero Benefit for Children, the Valero Energy
							Foundation’s annual charitable fundraiser focusing on children in
							need, returns for its 18th year to the magnificent JW Marriott San
							Antonio Hill Country Resort & Spa and TPC San Antonio. The
							excitement begins on Sunday, April 4 with our extraordinary
							Welcome Party immediately following the conclusion of the Valero
							Texas Open, then continues on Monday, April 5 with golf outings in
							and around San Antonio, and sporting clays tournaments.
						</p>

						{notice.type && <Notice data={notice} />}

						{/*<Assignments
              golf={golf.assignments}
              sporting={sporting.assignments}
      />*/}

						<div id="sponsor-packages">
							<div>
								<button
									type="button"
									className="naked"
									onClick={() => handleToggle("level")}
								>
									<h3>
										<span>{level.name}</span>
										<i
											className={
												open.level
													? "fa fa-angle-down fa-2x"
													: "fa fa-angle-right fa-2x"
											}
										/>
									</h3>
								</button>
								<div className={open.level ? "" : "hidden"}>
									<div dangerouslySetInnerHTML={createMarkup(level.html)} />
								</div>
							</div>
						</div>

						<div id="dashboard-grid">
							<Link to="/dashboard/invite">
								<div>
									<i
										className="fa fa-envelope-o"
										style={{ fontSize: "30px" }}
									/>

									<span>Add / Invite Guests</span>
								</div>
								<small>
									Place or invite guests to spots in Golf, Sporting Clays,
									Welcome Party and Gift Package.
								</small>
							</Link>

							<Link to="/dashboard/statuses">
								<div>
									<i className="fa fa-table" style={{ fontSize: "32px" }} />

									<span>View All Guests</span>
								</div>
								<small>
									Snapshot view of all your current guests statuses for each
									event.
								</small>
							</Link>

							<Link to="/dashboard/invoice">
								<div>
									<i
										className="fa fa-file-text-o"
										style={{ fontSize: "30px" }}
									/>
									<span>View Invoice</span>
								</div>
								<small>
									Print out your current invoice, view payment options and
									payments received to date.
								</small>
							</Link>

							<Link to="/dashboard/contact">
								<div>
									<i
										className="fa fa-pencil-square-o"
										style={{ fontSize: "30px" }}
									/>

									<span>Update Contact Info</span>
								</div>
								<small>
									Update your contact information as the main contact of this
									registration.
								</small>
							</Link>

							<Link to="/dashboard/users">
								<div>
									<i className="fa fa-user-o" style={{ fontSize: "30px" }} />

									<span>Add Dashboard Users</span>
								</div>
								<small>
									Delegate access to your dashboard and guest management to
									additional users.
								</small>
							</Link>

							<Link to="/dashboard/asset">
								<div>
									<i
										className="fa fa-address-card-o"
										style={{ fontSize: "30px" }}
									/>

									<span>Digital Asset Contact</span>
								</div>
								<small>
									Update your contact responsible for emailing the digital
									Valero Texas Open tickets to your Guests.
								</small>
							</Link>

							<Link to="/dashboard/upload">
								<div>
									<i className="fa fa-upload" style={{ fontSize: "30px" }} />

									<span>Upload Logo & Assets</span>
								</div>
								<small>
									Upload your corporate logo and other asset files (helpful to
									have available as needed by BFC).
								</small>
							</Link>

							<Link to="/dashboard/hotel">
								<div>
									<i
										className="fa fa-building-o"
										style={{ fontSize: "30px" }}
									/>

									<span>Manage Hotel Occupants</span>
								</div>
								{!level.jwStatus ? (
									<small>
										Book hotel reservations at off-site property hotels.
									</small>
								) : isAllowedHotel(level.id) ? (
									<small>
										Add a payment method to request hotel rooms at the JW
										Marriott and manage occupants under your allotment.
									</small>
								) : (
									<small>
										Book hotel reservations at off-site property hotels.
									</small>
								)}
							</Link>
						</div>

						<div className="blocktext" style={{ marginTop: "25px" }}>
							Looking to move your Golf or Sporting Clay guests to other
							foursomes? Use the option on the{" "}
							<Link to="/dashboard/statuses">View All Guests</Link> page.
						</div>

						{golf.data.length > 0 && (
							<Table
								details={golf}
								id="golf"
								open={open.golf}
								toggle={handleToggle}
							/>
						)}
						{sporting.data.length > 0 && (
							<Table
								details={sporting}
								id="sporting"
								open={open.sporting}
								toggle={handleToggle}
							/>
						)}
						{welcome.data.length > 0 && (
							<Table
								details={welcome}
								id="welcome"
								open={open.welcome}
								toggle={handleToggle}
							/>
						)}
						{gift.data.length > 0 && (
							<Table
								details={gift}
								id="gift"
								open={open.gift}
								toggle={handleToggle}
							/>
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={1} user={user} />

						<div dangerouslySetInnerHTML={createMarkup(html.right)} />
					</div>
				</>
			)}
		</>
	);
};

export default Dashboard;
